import { createFileRoute } from '@tanstack/react-router'
import z from 'zod'
import { AppContainer } from '~/components/new/app-ui/app-container'
import { AppHeader } from '~/components/new/app-ui/app-header'
import { CategoryMultiCombobox } from '~/components/new/app-ui/category-multi-combobox'
import { StoreCombobox } from '~/components/new/app-ui/store-combobox'
import { Title } from '~/components/new/app-ui/title'
import { withResourcePermission } from '~/components/RequireResourcePermission'
import { PlatformStockDeclarationDialog } from '~/components/routes/platform-stocks/declaration/platform-stock-declaration-dialog'
import { PlatformStockTable } from '~/components/routes/platform-stocks/stock/platform-stock-table'

export const Route = createFileRoute('/_authenticated/platform-stocks/')({
  component: withResourcePermission('platform-stocks', 'read')(PlatformStocksPage),
  validateSearch: z.object({
    storeReference: z.string().optional(),
    categoryIds: z.array(z.number()).optional(),
    search: z.string().optional(),
    page: z.number().optional(),
    pageSize: z.number().optional(),
  }),
})

function PlatformStocksPage() {
  const navigate = Route.useNavigate()
  const {
    storeReference,
    categoryIds = [],
    search = '',
    page = 1,
    pageSize = 10,
  } = Route.useSearch()

  return (
    <>
      <AppHeader>
        <Title>Stock Plateforme</Title>
      </AppHeader>

      <AppContainer>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <StoreCombobox
              valueField="checkpointStoreRef"
              storeType="warehouse"
              withAll
              value={storeReference ?? null}
              onChange={(v) =>
                navigate({
                  search: (prev) => ({ ...prev, storeReference: v ?? undefined, page: undefined }),
                })
              }
              className="w-72"
            />

            <CategoryMultiCombobox
              value={categoryIds}
              onChange={(ids) =>
                navigate({
                  search: (prev) => ({
                    ...prev,
                    categoryIds: ids.length ? ids : undefined,
                    page: undefined,
                  }),
                })
              }
              className="w-72"
            />
          </div>

          <PlatformStockDeclarationDialog storeReference={storeReference} />
        </div>

        <PlatformStockTable
          storeReference={storeReference}
          categoryIds={categoryIds}
          search={search}
          page={page}
          pageSize={pageSize}
          onNavigate={(params) => navigate({ search: (prev) => ({ ...prev, ...params }) })}
        />
      </AppContainer>
    </>
  )
}
